import axios from 'axios';
import getUrl from 'utils/getUrl';
import { toApiBlockFormat, toAppBlockFormat } from 'sharedParts';

import { generateApiError } from './utils/apiErrorMessages';

const saveBlockList = (
  collectionPath,
  entityId,
  { blockList, sectionName, activeSectionOrderMap },
) =>
  axios
    .post(getUrl.apiV2(`${collectionPath}/${entityId}/items`), {
      section: sectionName,
      data: blockList.map(toApiBlockFormat),
      order_map: activeSectionOrderMap,
    })
    .catch(generateApiError())
    .then(({ data: { data } }) => {
      const result = {};
      for (const { id, attributes } of data) {
        result[attributes.client_uuid] = toAppBlockFormat({
          id,
          ...attributes,
        });
      }
      return result;
    });

export default saveBlockList;
